import { render, staticRenderFns } from "./StatusTab.vue?vue&type=template&id=74cdef98&"
import script from "./StatusTab.vue?vue&type=script&lang=ts&"
export * from "./StatusTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports